import { styled } from '@mui/material';
import { InfoCircleFill } from '@styled-icons/bootstrap/InfoCircleFill';
import hintIcon from 'assets/img/icons/idea.svg';
import { InfoTooltip, ThemeTypography } from 'DesignSystem';
import React, { ReactNode } from 'react';

interface IProps {
  variant: 'INFO' | 'HINT';
  helperText: string;
  hoverText?: ReactNode;
}

const Icon = styled('div')(({ theme }) => ({
  marginRight: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
}));

const HintIcon = styled('img')(() => ({
  width: 16,
  pointerEvents: 'none',
}));

const HelperTextWrapper = styled('div')(({ theme }) => ({
  color: theme.palette.grey[500],
  display: 'flex',
  alignItems: 'center',
}));

export const InlineHelperText: React.FC<IProps> = ({ variant, helperText, hoverText }) => {
  return (
    <HelperTextWrapper>
      {hoverText ? (
        <InfoTooltip text={hoverText} />
      ) : (
        <Icon>
          {variant === 'INFO' ? <InfoCircleFill size={14} /> : <HintIcon src={hintIcon} />}
        </Icon>
      )}

      <ThemeTypography variant="BODY_MEDIUM" color="GRAY">
        {helperText}
      </ThemeTypography>
    </HelperTextWrapper>
  );
};
